export default "__VITE_ASSET__BwrAfURL__"